import React from "react";
import { Input } from "antd";
import "./formInput.scss";

const InputWithLabel = ({
  label,
  value,
  valueObj ,
  onChange = () => {},
  className = "",
  style = {},
  ...other
}) => {
  const finalValue = value ? value : valueObj.value || "";
  return (
    <div className="input-with-label__wrapper w100">
      <Input
        prefix={<span className="input-with-label__label">{label}</span>}
        value={finalValue}
        onChange={onChange}
        style={style}
        className={`input-with-label__input ${className}`}
        {...other}
      />
    </div>
  );
};

export default InputWithLabel;
